export default __webpack_public_path__ + "static/media/IconCelebrate.754c9fea.svg";